import { Button, Form, Input } from 'antd'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { resetPassword, logoutUser } from './store/store'
import { resetRecoveryState } from './store/recovery'
import { ErrorMessage } from './ErrorMessage'
import { SuccessMessage } from './SuccessMessage'

function ResetPassword({ token }) {
  const dispatch = useDispatch()
  const recovery = useSelector(state => state.recovery)

  useEffect(() => {
    dispatch(resetRecoveryState())
  }, [dispatch])

  useEffect(() => {
    if (recovery.resetDone) {
      // The old JWT was invalidated server-side (pwd_hash claim); clear it so
      // App falls back to the login screen, and drop the token from the URL.
      logoutUser()
      window.history.replaceState(null, '', window.location.pathname)
    }
  }, [recovery.resetDone])

  const handleSubmit = (values) => {
    resetPassword({
      token: token,
      new_password: values.new_password
    })
  }

  return (
    <div className="reset-password">
      <h2>Восстановление пароля</h2>
      <Form
        name="reset-password"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        onFinish={handleSubmit}
        autoComplete="off"
      >
        <Form.Item
          label="Новый пароль"
          name="new_password"
          hasFeedback
          rules={[{ required: true, message: 'Введите новый пароль' }]}
        >
          <Input.Password autoComplete="new-password" />
        </Form.Item>

        <Form.Item
          label="Подтверждение пароля"
          name="confirm_password"
          dependencies={['new_password']}
          hasFeedback
          rules={[
            { required: true, message: 'Введите пароль еще раз для подтверждения' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('new_password') === value) {
                  return Promise.resolve()
                }

                return Promise.reject(new Error('Пароли, введенные Вами, не совпадают'))
              }
            })
          ]}
        >
          <Input.Password autoComplete="new-password" />
        </Form.Item>

        <ErrorMessage error={ recovery.error } />
        <SuccessMessage message={ recovery.resetDone && 'Пароль изменён. Войдите с новым паролем.' } />

        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button type="primary" htmlType="submit" loading={recovery.isLoading}>
            Восстановить пароль
          </Button>
        </Form.Item>
      </Form>
    </div>
  )
}

export default ResetPassword